import { Trash2, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";

interface Conversation {
  id: string;
  title: string;
  createdAt: Date;
}

interface ChatSidebarProps {
  conversations: Conversation[];
  currentConvId: string;
  onSelectConv: (id: string) => void;
  onNewChat: () => void;
  isOpen: boolean;
  onToggle: (open: boolean) => void;
}

export default function ChatSidebar({
  conversations,
  currentConvId,
  onSelectConv,
  isOpen,
  onToggle,
}: ChatSidebarProps) {
  return (
    <>
      {/* Overlay for mobile */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 lg:hidden z-40"
          onClick={() => onToggle(false)}
        />
      )}

      {/* Sidebar */}
      <div
        className={`w-64 bg-sidebar-background border-r border-border flex-shrink-0 lg:static fixed inset-y-0 left-0 transform transition-transform duration-300 z-50 ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } lg:translate-x-0`}
      >
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b border-border">
            <h1 className="font-bold text-lg">Chat</h1>
            <button
              onClick={() => onToggle(false)}
              className="p-2 hover:bg-sidebar-accent rounded-lg lg:hidden"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Conversations */}
          <ScrollArea className="flex-1">
            <div className="space-y-2 p-4">
              {conversations.map((conv) => (
                <div key={conv.id} className="group">
                  <button
                    onClick={() => {
                      onSelectConv(conv.id);
                      onToggle(false);
                    }}
                    className={`w-full text-left px-3 py-2 rounded-lg transition ${
                      currentConvId === conv.id
                        ? "bg-sidebar-primary text-sidebar-primary-foreground"
                        : "text-sidebar-foreground hover:bg-sidebar-accent"
                    }`}
                  >
                    <p className="text-sm truncate">{conv.title}</p>
                    <p className="text-xs opacity-60">
                      {conv.createdAt.toLocaleDateString()}
                    </p>
                  </button>
                </div>
              ))}
            </div>
          </ScrollArea>

          {/* Footer */}
          <div className="border-t border-border p-4">
            <Button
              onClick={() => {
                onToggle(false);
              }}
              variant="outline"
              className="w-full justify-center"
            >
              Settings
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}